import * as yup from 'yup';

const formValidationSchema = yup.object().shape({
  signer: yup.string().required('Debe haber un firmante.'),
});

export { formValidationSchema };
